export default "__VITE_ASSET__87b9d49c__"